export const isYouTubeVideoLink = (iframeSrc: string) => {
  const youtubeDomain = "www.youtube.com";
  const youtubeShortDomain = "youtu.be";

  const url = new URL(iframeSrc);
  const hostname = url.hostname;

  return hostname === youtubeDomain || hostname === youtubeShortDomain;
};
